// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"a959eb82","137":"33193737","180":"c2c42b95","343":"82cd29ff","481":"70d8ee0b","488":"f1dc7667","562":"22ae3899","663":"274f35e0","940":"ac64551c","941":"efdc8f27"}[chunkId] + ".chunk.js";
};